import { render, staticRenderFns } from "./ShippingRecordModal.html?vue&type=template&id=1cabaa32&scoped=true&external"
import script from "./ShippingRecordModal.ts?vue&type=script&lang=ts&external"
export * from "./ShippingRecordModal.ts?vue&type=script&lang=ts&external"
import style0 from "./ShippingRecordModal.css?vue&type=style&index=0&id=1cabaa32&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cabaa32",
  null
  
)

export default component.exports